// extracted by mini-css-extract-plugin
module.exports = {"background":"Landing_background__L7ZKj","title":"Landing_title__eBdNa","button":"Landing_button__wyUxN"};